import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import appState from './state/AppStateContainer';

i18n
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  .use({
    type: 'languageDetector',
    detect: () => appState.state.language || 'sv',
    cacheUserLanguage: (lang) => {
      appState.setLanguage(lang);
    }
  })
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next: for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend: {
      // path where resources get loaded from
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // path to post missing resources
      addPath: '/locales/missing/{{lng}}/{{ns}}.json',
    },
    debug: false,
    fallbackLng: 'sv',
    initAsync: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      formatSeparator: '_'
    },
    ns: [
      'auth',
      'companySearch',
      'contract',
      'dashboard',
      'email',
      'erfa',
      'excel',
      'files',
      'help',
      'invoices',
      'login',
      'marketing',
      'newSupplier',
      'organizations',
      'pagination',
      'profile',
      'projects',
      'quotation',
      'rating',
      'salesTool',
      'reports',
      'requests',
      'settings',
      'shared',
      'signup',
      'site',
      'supplierDatabase',
      'supplierMonitoring',
      'supplierPresentation',
      'translation',
      'updates',
      'users',
      'validation'
    ],
    supportedLngs: ['sv', 'en', 'nb', 'da'],
    preload: [],
    saveMissing: true,
    saveMissingTo: 'all',
    react: {
      useSuspense: true
    },
  });

export default i18n;
